var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 43,
    viewBox: "0 0 45 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram-round-svgrepo-com (2) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.7851 25.3189C24.9064 25.3189 26.6429 23.6396 26.6429 21.5696C26.6429 20.7549 26.3691 19.9984 25.9158 19.3832C25.2144 18.4438 24.0767 17.8203 22.7936 17.8203C21.5105 17.8203 20.3729 18.4355 19.6714 19.3832C19.2181 19.9984 18.9444 20.7549 18.9444 21.5696C18.9358 23.6396 20.6637 25.3189 22.7851 25.3189Z",
    fill: "#FFC185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.2016 16.9971V13.8547V13.3892H30.7226L27.4893 13.3975L27.5064 17.0054L31.2016 16.9971Z",
    fill: "#FFC185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.7728 21.578C28.7728 24.7869 26.0869 27.3973 22.7851 27.3973C19.4833 27.3973 16.7974 24.7869 16.7974 21.578C16.7974 20.8049 16.9599 20.065 17.2422 19.3916H13.9746V28.1039C13.9746 29.2262 14.9155 30.1406 16.0703 30.1406H29.4999C30.6547 30.1406 31.5956 29.2262 31.5956 28.1039V19.3916H28.328C28.6188 20.065 28.7728 20.8049 28.7728 21.578Z",
    fill: "#FFC185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.7846 0.295898C10.6895 0.295898 0.886719 9.82289 0.886719 21.5778C0.886719 33.3328 10.6895 42.8598 22.7846 42.8598C34.8798 42.8598 44.6826 33.3328 44.6826 21.5778C44.6826 9.82289 34.8798 0.295898 22.7846 0.295898ZM33.7336 19.3914V28.1037C33.7336 30.3732 31.8346 32.2188 29.4994 32.2188H16.0698C13.7346 32.2188 11.8357 30.3732 11.8357 28.1037V19.3914V15.0436C11.8357 12.7741 13.7346 10.9285 16.0698 10.9285H29.4994C31.8346 10.9285 33.7336 12.7741 33.7336 15.0436V19.3914Z",
    fill: "#FFC185"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.af87dffeda9208bc4c95027a74984b28.svg";
export { ForwardRef as ReactComponent };